export const POPUP_MESSAGE_WINDOW_TYPE = {
    'GROUP_LIST_WINDOW' : 0,
    'MESSAGE_LIST_WINDOW' : 1,
    'GROUP_CREATE_WINDOW': 2
};

export const SSO_ENABLED_CLIENTS = {
    'thehill.org': 'wave-saml'
};
